import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
// @ts-expect-error untyped dependency
import Url from 'PatternValidationJS/patterns/Url';
export const isValidUrl = url => Url.test(url, {
  requireProtocol: true
});
export const getPropertiesSettingsUrl = (objectTypeId, propertyName) => `${getFullUrl('app')}/property-settings/${PortalIdParser.get()}/properties?type=${objectTypeId}&action=edit&property=${propertyName}`;

// external urls
export const getKbUrl = path => `${getFullUrl('knowledge', {
  envOverride: 'prod',
  hubletOverride: 'na1'
})}/${path}`;
export const getConsentOptionsSettingsUrl = () => `${getFullUrl('app')}/settings/${PortalIdParser.get()}/data-privacy/consent-options`;
export const getManageSubscriptionsSettingsUrl = () => `${getFullUrl('app')}/settings/${PortalIdParser.get()}/marketing/email/types`;